module.exports = __webpack_public_path__ + "static/media/lightCrossIcon.76387e07.svg";